import {Popout as _Popout} from './components/popout'
import {UserList} from '~/components/select'
import './styles/index.less'

export * from './components'

export const Popout = ({type, width = 250, ...rest}) => {
	// UserList renders a Select under the hood, which handles trigger and floating logic itself
	if (type === 'users') return <UserList width={width} {...rest} />

	return <_Popout type={type} width={width} {...rest} />
}
